import {
    AnimationLoadingBaseController,
    IAnimationControllerConfiguration,
    ILoadingBaseController,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../AnimationContents';

export class PreloaderGameController extends AnimationLoadingBaseController implements ILoadingBaseController {
    public $model: any;

    public constructor(@Inject private _options: any) {
        super('PreloaderGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.LOADER_SCREEN_JSON,
            libraryName: 'loader_screen',
        };
    }

    protected onInitialize(): void {
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    public onLoadingProgress(progress: number): void {
    }

    public onHide(): void {
    }

    public onShow(): void {
    }
}
